import React, {useState, useEffect}  from 'react';
import { saveAs } from 'file-saver';
import ShowFAQ from './ShowFAQ';
import SelectorBar from '../StockItems/SelectorBar';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as ServerComms from '../utilities/ServerComms';
import NormalBtn from '../StockItems/NormalBtn';

function App(props) {

  var width = props.width;
  var codeSet = props.code;
  var codeOutputID = codeSet[0].v;
  var code = codeSet[1].v;
  var htmlCodeReference = codeSet[2].v;
  var programSetID = props.programSetID;
  var sessionID = props.sessionID;
  var signKey = props.signKey;
  var userID = props.userID;
  var nosCredits = props.nosCredits;
  var setNosCredits = props.setNosCredits;
  var addToExtraScreen = props.addToExtraScreen;
  var setSelectedStep = props.setSelectedStep;
  var clickBack = props.clickBack;

  var initial = false;
  if (code.length > 0){
    initial = {t:0, v:0};
  }

  const [showWhat, setShowWhat] = useState(initial);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(-1);
  const [compileDirectory, setCompileDirectory] = useState('');

  function getCompileDirectory(){
    function failFunction(e){
      console.log(e);
    }

    function postCompileDirectory(response){
      setCompileDirectory(response.v[0].v);
    }

    ServerComms.fetchSomething({u:'getCompileDirectory', programSetID, userID, signKey, sessionID}, postCompileDirectory, failFunction);

  }

  useEffect(()=>{
    getCompileDirectory();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  function clickDownload(){
    var JSZip = require('jszip');
    var zip = new JSZip();
    code.forEach((aFile, index2)=>{
      var fileName = aFile.v[0].v;
      var pageContentsA = aFile.v[1].v;
      if (fileName === 'App.css'){
        pageContentsA = pageContentsA.split('unicodeUp').join("↑").split("unicodeDown").join("↓");
      }
      zip.file(fileName, pageContentsA);
    })

    zip.generateAsync({type:"blob"})
    .then(function(content) {
        // see FileSaver.js
        saveAs(content, "instructions.zip");
    });

  }

  function doDirectory(zip, responseIn){
    responseIn.forEach((aFile, index)=>{
      if (aFile.v[0].v === 'dir'){
        var dir = aFile.v[1].v;
        var contents = aFile.v[2].v;
        var zip1 = zip.folder(dir);
        doDirectory(zip1, contents);
      }else if (aFile.v[0].v === 'file'){
        var fileName = aFile.v[1].v;
        var pageContentsA = aFile.v[2].v.split('unicodeUp').join("↑").split("unicodeDown").join("↓");
        zip.file(fileName, pageContentsA);
      }
    })

  }
  function postCompile(responseIn){
    var JSZip = require("jszip");
    var zip = new JSZip();
    doDirectory(zip, responseIn.v);
    zip.generateAsync({type:"blob"})
    .then(function(content) {
        saveAs(content, "compiled.zip");
    });

  }
  var butFront = [];

    var text;
    var textToShow;
    if (showWhat){
      if (showWhat.z === 'compile'){

        var creditsRequired = 10;

        function failFunction(){
          setIsSubmitted(-1)
        }

        function postFunction(responseIn){
          if (responseIn.t === 'atom'){
            window.alert('Insufficient credits');
          }else{
            console.log(responseIn);
            setNosCredits(responseIn.v[0].v);
            // postCompile(responseIn.v[1].v[2]);
            setTimeout(function(){ 
              setSelectedStep(['de', 'coded', responseIn.v[1].v])
              // setHtmlCode(responseIn.v[1]);
            }, 100);
          }
          setIsSubmitted(-1);
        }

        function getCode(){
          if (creditsRequired > nosCredits){
            addToExtraScreen({t:'credits',v:creditsRequired});
          }else{
            if (isSubmitted === -1){

              var passObject = {
                  u:'compileHTML',
                  programSetID,
                  codeOutputID,
                  sessionID,
                  signKey,
                  userID,
                };
              setIsSubmitted(0);
              ServerComms.fetchSomething(passObject, postFunction, failFunction, []);
            }

          }
        }

        if (!htmlCodeReference){
          var compileText = 'Compile';
          if (isSubmitted > -1){
            compileText = 'Compiling...';
          }

          function changeCompileDirectory(e){
            var p = window.prompt('Which directory would you be compiling the website into? Leave blank if its the main website link (e.g. leave blank if it is at www.mywebsite.com, type xxx if it is at www.mywebsite.com/xxx', compileDirectory);
            if (p === null){              
            }else{

              function failFunction(e){
                console.log(e);
              }

              function postCompileDirectory(response){
                setCompileDirectory(response.v[0].v);
              }

              ServerComms.fetchSomething({u:'updateCompileDirectory', compileDirectory:p, programSetID, userID, signKey, sessionID}, postCompileDirectory, failFunction);


            }
          }

          text = <div>Convert the React code into HTML code that you can directly copy into your server. Each conversion may take a few minutes, and costs 10 credits.<br/><br/>
                    <NormalBtn title={compileText} onClick={getCode} icon='ic:outline-get-app'/>
                    <br/><br/>
                <div>Click <u><a href='https://www.cherryservers.com/blog/how-to-install-and-configure-apache-web-server-on-ubuntu-20-04'>here</a></u> to learn how to install your Apache server. You can then load the compiled files into the <span style={{cursor:'pointer', textDecoration:'underline'}} onClick={changeCompileDirectory}>/var/www/html/{compileDirectory}</span> directory of your server.</div>

            </div>;
//
        }else{
          var text1 = 'https://www.cues.sg/generatedCode/'+htmlCodeReference+'.zip';
          function cl(e){
            window.open(text1);
          }
          // butFront = [{t:'Download Code',i:'HTMLdownload', a:'ic:outline-get-app'}];
          text = <div>You can get the downloaded code at <span style={{cursor:'pointer', textDecoration:'underline'}} onClick={cl}>{text1}</span>. Copy the contents of the build directory into your server directory. The code will be kept online for 7 days. Thank you.<br/><br/>
            </div>;
        }

//
      }else if (showWhat.t === -1){
        text = <ShowFAQ />

      }else{

        if (code[showWhat.t].v[1].t === 'string' || code[showWhat.t].v[1].t === 'binary'){
          textToShow = code[showWhat.t].v[1].v;
        }
        if (code[showWhat.t].v[0].v === 'App.css'){
          textToShow = textToShow.split("unicodeUp").join("↑").split("unicodeDown").join("↓");        
        }
        text = StyleFunctions.convertToDivs(textToShow, width);

      }
    }


  function copyText() {
    navigator.clipboard.writeText(textToShow);
  }

    function clickShowcase(aCell){
      setShowWhat({t:aCell, v:0});
    }

    function clickItem(aCell){
      return function(e){
        if (aCell === 'Download'){
          clickDownload();
        }else if (aCell === 'Delete'){
          var pp = window.confirm("Are you sure you want to delete this code? You will have to pay to regenerate it.");
          if (pp){
            var passObject = {
                u:'deleteCode',
                programSetID,
                sessionID,
                signKey,
                codeOutputID,
                userID,
              };
            function postFunction(){
              clickBack();
            }
            setIsDeleting(true);
            ServerComms.fetchSomething(passObject, postFunction, postFunction, []);
          }
        }else if (aCell === 'Copy'){
          copyText();
        }else if (aCell === 'Close'){
              clickBack();
        }else if (aCell === 'HTML'){
          setShowWhat({z:'compile'});
        }else if (aCell === 'Back'){
              clickBack();
        // }else if (aCell === 'HTMLdownload'){
        //   postCompile(htmlCode);

        }
      }
    }


    var solOut = code.map((aSol, index)=>{
      return {t:aSol.v[0].v, i:index}
    });

    solOut.push({t:'FAQ', i:-1});

    var but = [];
//
    var selBar;
    if (showWhat && showWhat.z === 'compile'){
      but = butFront.concat([{t:'Back',i:'Back', a:'material-symbols:arrow-back'}]);

    }else{
     
      but = [{t:'Compile into HTML',i:'HTML',a:'ph:file-html'}, {t:'Download',i:'Download',a:'akar-icons:download'}, {t:'Copy Page',i:'Copy',a:'akar-icons:copy'}, {t:isDeleting ? 'Deleting...' : 'Delete',i:'Delete', a:'fe:trash'}, {t:'Close',i:'Close', a:'ant-design:close-circle-outlined'}];

      selBar = <div className="col-lg-10 mx-auto"> 
        <br/><br/>
        <SelectorBar options={solOut} useLight={true} currentAnswer={showWhat.t} setSelections={clickShowcase}/>
      </div>
    }
//    
    var buttons = but.map((aButton, index)=>{
      return <div className="col-lg-2 mx-auto"> 
        <NormalBtn title={aButton.t} onClick={clickItem(aButton.i)} icon={aButton.a}/>
      </div>
    })

//
  return <div className="container">
      <div className="row mb-4">
      {selBar}</div>
      <div className="row mb-4">
        {buttons}
      </div>


      <div className="row mb-4">
      <div className="col-lg-10 mx-auto text-left"> 
        <p className="lead mb-0">{text}</p>
      </div>
      </div>

      </div>

}


export default App;
